import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import ResourceSelect from "../../../../../../components/Inputs/ResourceSelect";
import { renderSettingsResourceLabel } from "../../../../../../utils/helpers/settings";
import { getSettingsResourceSearchFilters } from "../../../../../../utils/helpers/settings";

export const useUnionFilter = () => {
    const { t } = useTranslation();

    return useMemo(() => ({
        name: "union",
        label: t("union"),
        type: "resource-select",
        component: (
            <ResourceSelect
                labelPropName="description"
                renderLabel={renderSettingsResourceLabel}
                resourcePath="/union"
                hasSearch
                mode="multiple"
                getSearchFilters={getSettingsResourceSearchFilters}
            />
        ),
    }), [t]);
}